import { createContext, useContext } from 'react';
const MilestoneTableSizeContext = /*#__PURE__*/createContext('full');
export const MilestoneTableSizeProvider = MilestoneTableSizeContext.Provider;
export const useMilestoneTableSize = () => useContext(MilestoneTableSizeContext);